module.exports = __webpack_public_path__ + "static/media/distortion_sl_active.a3f57a5e.png";